import { Button } from '@material-ui/core'
import { styled } from '@material-ui/styles'

export const CustomButton = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})
